module.exports = __webpack_public_path__ + "static/media/8900_MasterBath2.56a86a6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/8900_MasterBath2.jpg
// module id = 579
// module chunks = 0